// These are the resources that backend is granting the Guest/Viewer roles read access to
// but we want to hide from the UI if the user does not have write access
// That's until we update the components and integrate the new read/write permissions system fully to the buttons and controls
// Then we can give read access to these resources for viewers (with no write access) and they will see the resources in the UI
const listOfResourcesToHide = [
    'users',
    'assets',
    'settings',
    'integrations',
    'rekognition',
];

// This is to keep the current prod permissions behavior (hiding certain resources from viewers)
// This is a temporary measure and will be removed in the future as we integrate the new permissions into more of the components and controls
// So for now, if a user does not have write permissions to a resource (not owner or admin), we will hide the read permission as well
export default {
    order: 40,
    apply: (permissionsMap = {}, grantedPermissions = [], context = {}) => {
        const out = { ...permissionsMap };
        listOfResourcesToHide.forEach(resource => {
            if (out[resource]) {
                if(!out[resource].write) {
                    console.warn(`Permissions: hiding read permission for resource: ${resource} because write permission is not granted`);
                    delete out[resource].read;
                }
            }
        });
        return out;
    }
}